import { useEffect, useMemo, useState } from "react";
import { useServerTimeOffsetMs } from "../../api/useServerNow";

/** How often to refresh basket deadline UI while there are pending basket days (no RTDB). */
export const BASKET_DEADLINE_RECHECK_MS = 30_000;

/** Firebase server time; advances on a timer when {@link recheckEnabled} so cutoffs update with the drawer open. */
export function useBasketServerNow(recheckEnabled: boolean): Date | undefined {
    const serverOffsetMs = useServerTimeOffsetMs();
    const [tick, setTick] = useState(0);

    useEffect(() => {
        if (!recheckEnabled || serverOffsetMs === undefined) {
            return undefined;
        }
        const id = window.setInterval(() => setTick(n => n + 1), BASKET_DEADLINE_RECHECK_MS);
        return () => window.clearInterval(id);
    }, [recheckEnabled, serverOffsetMs]);

    return useMemo(() => {
        if (serverOffsetMs === undefined) {
            return undefined;
        }
        void tick;
        return new Date(Date.now() + serverOffsetMs);
    }, [serverOffsetMs, tick]);
}
